/* Tees theme (tt-*) behaviour. No dependencies. */
(() => {
  /* ---------- Horizontal product scroller with arrows + progress bar ---------- */
  if (!customElements.get('tt-scroller')) {
    customElements.define(
      'tt-scroller',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;
          this.bar = this.querySelector('[data-bar]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          const step = () => {
            const item = this.track.children[0];
            return item ? item.getBoundingClientRect().width + 16 : this.track.clientWidth;
          };
          this.prev && this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
          this.next && this.next.addEventListener('click', () => this.track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          window.addEventListener('resize', () => this.update());
          this.update();
        }
        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const ratio = this.track.scrollWidth ? this.track.clientWidth / this.track.scrollWidth : 1;
          if (this.bar) {
            this.bar.style.width = `${Math.max(10, ratio * 100)}%`;
            this.bar.style.left = max > 0 ? `${(this.track.scrollLeft / max) * (100 - ratio * 100)}%` : '0%';
          }
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
        }
      }
    );
  }

  /* ---------- Bottom jump-links bar: shows after the buy box scrolls away ---------- */
  if (!customElements.get('tt-jump-bar')) {
    customElements.define(
      'tt-jump-bar',
      class extends HTMLElement {
        connectedCallback() {
          const target = document.querySelector('product-info .product-form__submit') || document.querySelector('product-info');
          if (!target) return;
          this.io = new IntersectionObserver(([entry]) => {
            this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
          this.io.observe(target);
        }
        disconnectedCallback() {
          this.io && this.io.disconnect();
        }
      }
    );
  }

  /* ---------- Fit guide: switch photo by size ---------- */
  if (!customElements.get('tt-fit-models')) {
    customElements.define(
      'tt-fit-models',
      class extends HTMLElement {
        connectedCallback() {
          this.models = [...this.querySelectorAll('[data-model]')];
          this.tabs = [...this.querySelectorAll('[data-size]')];
          if (this.models.length < 2) return;
          this.index = 0;
          this.tabs.forEach((tab) => tab.addEventListener('click', () => this.show(Number(tab.dataset.size))));
          const prev = this.querySelector('[data-prev]');
          const next = this.querySelector('[data-next]');
          prev && prev.addEventListener('click', () => this.show((this.index - 1 + this.models.length) % this.models.length));
          next && next.addEventListener('click', () => this.show((this.index + 1) % this.models.length));
        }
        show(i) {
          this.index = i;
          this.models.forEach((m, n) => m.classList.toggle('is-active', n === i));
          this.tabs.forEach((t, n) => t.setAttribute('aria-selected', String(n === i)));
        }
      }
    );
  }
  /* ---------- Collection cards: color dots switch the photo and links ---------- */
  document.addEventListener('click', (event) => {
    const dot = event.target.closest('.tt-shop-card__swatch');
    if (!dot) return;
    const card = dot.closest('[data-tt-shop-card]');
    if (!card) return;
    card.querySelectorAll('.tt-shop-card__swatch').forEach((el) => el.setAttribute('aria-pressed', el === dot ? 'true' : 'false'));
    const img = card.querySelector('.tt-shop-card__photo');
    if (img && dot.dataset.src) {
      img.srcset = dot.dataset.srcset || '';
      img.src = dot.dataset.src;
    }
    if (dot.dataset.url) card.querySelectorAll('[data-tt-card-link]').forEach((link) => (link.href = dot.dataset.url));
  });
})();
